export default __webpack_public_path__ + "cb5362343ca3bbe1013dd23709034020.webp";